import {
  awaitAnimate,
  Particle,
  ParticleModes,
} from "../../../engine/anims/Particle";

export const LookParticle = {
  mode: ParticleModes.DRAW_OVER_LAST,
  char: null,
  fg: null,
  bg: "rgba(100, 100, 200, 0.75)",
  animate: async (particle: Particle<void>) => {
    // eslint-disable-next-line no-constant-condition
    while (true) {
      await awaitAnimate({
        driver: particle.driver,
        from: "rgba(100, 100, 200, 0.75)",
        to: "rgba(125, 125, 225, 0.75)",
        duration: 1000,
        onUpdate: (latest) => {
          particle.bg = latest;
        },
      });

      await awaitAnimate({
        driver: particle.driver,
        from: "rgba(125, 125, 225, 0.75)",
        to: "rgba(100, 100, 200, 0.75)",
        duration: 1000,
        onUpdate: (latest) => {
          particle.bg = latest;
        },
      });
    }
  },
};
